// Build version string, "<lastTag|0.0.0>-<commitsSince>-g<shortHash>". Replaced at
// bundle time by esbuild `define` (tools/bundle.mjs → tools/version.mjs). In tests and
// unbundled dev the define is absent, so fall back to a dev marker.
declare const __BEACON_VERSION__: string | undefined;

export const VERSION: string =
  typeof __BEACON_VERSION__ === "string" ? __BEACON_VERSION__ : "0.0.0-0-gdev";
